module.exports = __webpack_public_path__ + "img/caret-left-square-fill.404033f1.svg";